import React from "react";
import ScalpDetoxBanner from "./../../../../../Images/Blog/Scalp_Detox/Banner.png";
const ScalpDetoxImg = () => {
  return (
    <div className="blogImg-content">
      <img src={ScalpDetoxBanner} alt="ScalpDetoxBanner" loading="lazy" />
    </div>
  );
};

export default ScalpDetoxImg;
